import httpAuth from "@/common/http/http-common";
import { OfficeDataDto, OfficeDefaultRateDto, OfficeDefaultRateFormsDto, OfficeFormDto, OfficeHourDto, OfficeHourFormDto, OfficePayrollFormDto, OfficeProfileDto, OfficeStatusFormDto, OfficeUserDto, OfficeUserFormDto } from "@/types/office.type";
import { PracticeFormDto } from "@/types/practice.type";
import { UserFormDto } from "@/types/user.type";

class OfficeProfileService {
  client = httpAuth("office-profile");

  async getUsersAsync(practiceId: number): Promise<OfficeUserDto[]> {
    const { data } = await this.client.get(`practice/${practiceId}/user/all`);

    return data;
  }

  async getOfficeHoursAsync(officeId: number): Promise<OfficeHourDto[]> {
    const { data } = await this.client.get(`office/${officeId}/hour/all`);

    return data;
  }

  async getOfficeDefaultRatesAsync(officeId: number): Promise<OfficeDefaultRateDto[]> {
    const { data } = await this.client.get(`office/${officeId}/rate/all`);

    return data;
  }

  async getByPracticeAsync(practiceId: number): Promise<OfficeProfileDto[]> {
    const { data } = await this.client.get(`practice/${practiceId}`);

    return data;
  }

  async savePracticeAsync(form: PracticeFormDto): Promise<number> {
    const { data } = await this.client.put("practice", form);

    return data;
  }

  async saveOfficeAsync(form: OfficeFormDto): Promise<number> {
    const { data } = await this.client.put("office", form);

    return data;
  }

  async saveOfficeRatesAsync(form: OfficeDefaultRateFormsDto): Promise<void> {
    await this.client.put("office/rates", form);
  }

  async saveOfficeHoursAsync(form: OfficeHourFormDto): Promise<void> {
    await this.client.put("office/hours", form);
  }

  async saveOfficeUserAsync(form: OfficeUserFormDto): Promise<void> {
    await this.client.put("office/user", form);
  }

  async saveOfficePayrollAsync(form: OfficePayrollFormDto): Promise<void> {
    await this.client.put("payroll", form);
  }

  async createUserAsync(form: UserFormDto): Promise<number> {
    const { data } = await this.client.put("user", form);

    return data;
  }

  async getOfficeDataAsync(): Promise<OfficeDataDto> {
    const { data } = await this.client.get("data");

    return data;
  }

  async createFavoriteAsync(officeId: number, userId: number): Promise<void> {
    await this.client.put(`office/${officeId}/user/${userId}/favorite`);
  }

  async deleteFavoriteAsync(officeId: number, userId: number): Promise<void> {
    await this.client.delete(`office/${officeId}/user/${userId}/favorite`);
  }

  async getPracticeDetailsAsync(practiceId: number): Promise<OfficeProfileDto[]> {
    const { data } = await this.client.get(`practice/${practiceId}/details`);

    return data;
  }

  async updateOfficeStatus(form: OfficeStatusFormDto): Promise<void> {
    await this.client.put("office/status", form);
  }
}

export default new OfficeProfileService();